import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = direction === 'left' ? -340 : 340;
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  const trendingArticles = articles.filter((a) => a.isHot || a.isNew).slice(0, 6);

  return (
    <section className="relative bg-background-950 py-14 md:py-20 overflow-hidden">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-primary-500/40 text-primary-400 text-xs font-medium">
              <i className="ri-flashlight-line w-3 h-3 flex items-center justify-center"></i>
              热门爆料
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mt-4 tracking-tight">
              今日必吃大瓜
            </h2>
            <p className="text-sm text-foreground-400 mt-2 max-w-md">
              实时追踪最新吃瓜爆料，一站掌握全网最热八卦动态
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 md:w-10 md:h-10 rounded-full border border-foreground-600/40 text-foreground-400 hover:text-white hover:border-primary-500/60 transition-all duration-200 flex items-center justify-center"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 md:w-10 md:h-10 rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 flex items-center justify-center"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollSnapType: 'x mandatory', msOverflowStyle: 'none', scrollbarWidth: 'none' }}
        >
          {trendingArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex-shrink-0 w-[280px] md:w-[320px]"
              style={{ scrollSnapAlign: 'start' }}
            >
              <div className="bg-background-50 rounded-xl overflow-hidden transition-all duration-300 group-hover:translate-y-[-4px]">
                <div className="relative w-full aspect-[4/3] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3 flex items-center gap-1.5">
                    {article.isHot && (
                      <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-[10px] font-bold">
                        HOT
                      </span>
                    )}
                    {article.isNew && (
                      <span className="px-2 py-0.5 rounded-full bg-primary-500 text-white text-[10px] font-bold">
                        NEW
                      </span>
                    )}
                  </div>
                </div>
                <div className="p-4">
                  <span className="text-[11px] font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                    {article.categoryName}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mt-2.5 line-clamp-2 leading-relaxed group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60">
                    <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                      <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                      {(article.views / 10000).toFixed(1)}万
                    </span>
                    <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                      <i className="ri-chat-3-line w-3 h-3 flex items-center justify-center"></i>
                      {(article.comments / 10000).toFixed(1)}万
                    </span>
                    <span className="text-[11px] text-foreground-400 ml-auto">
                      {article.date}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
}